import { IconButton } from "web/components"
import { formatAsBigNumber } from "web/services/format"

export default function TablePageSelector({
  currentPage,
  numberOfPages,
  numberOfRecords,
  recordsPerPage = 50,
  onPageChange,
  hasData,
}) {
  const hasPrev = currentPage !== 1
  const hasNext = currentPage !== numberOfPages

  const firstRecord = hasData ? (currentPage - 1) * recordsPerPage + 1 : 0
  const lastRecord = Math.min(firstRecord - 1 + recordsPerPage, numberOfRecords)

  const toString = (value) => formatAsBigNumber({ value })

  return (
    <div className="grid h-8 place-items-center rounded text-sm">
      <div className="flex items-center justify-between gap-x-1 px-1">
        <span>
          <IconButton
            size="small"
            name="chevron-left"
            disabled={!hasPrev}
            onClick={() => onPageChange(currentPage - 1)}
          />
        </span>
        <span>
          {toString(firstRecord)}-{toString(lastRecord)}&ensp;of&ensp;
          {toString(numberOfRecords)}
        </span>
        <span>
          <IconButton
            size="small"
            name="chevron-right"
            disabled={!hasNext}
            onClick={() => onPageChange(currentPage + 1)}
          />
        </span>
      </div>
    </div>
  )
}
